import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useMatch, useNavigate } from 'react-router-dom'
import { getChainById } from 'symbiosis-js-sdk'

import { IconButton } from '~/components/IconButton'
import { PageHeader } from '~/components/PageHeader'
import Select from '~/components/Select'
import Spinner from '~/components/Spinner'
import Tile from '~/components/Tile'
import { useVESISParams } from '~/hooks/useVESISParams'
import { CONFIG } from '~/lib/config'
import { isLockDateExpired } from '~/lib/isLockDateExpired'
import { useLockDetails } from '~/lib/useLockDetails'
import { useWallet, WalletStatus } from '~/lib/useWallet'

import { AboutLock } from './AboutLock'
import SettingsIcon from './assets/settings.svg'
import { NoActiveLock } from './NoActiveLock'
import { TotalStakingOverview } from './TotalStakingOverview'

import styles from './VESISPage.pcss'

const OPTIONS = CONFIG.vesis.map((vesisConfig) => {
	const chain = getChainById(vesisConfig.chain.id)

	return {
		label: chain.name,
		value: vesisConfig.slug,
	}
})

export function VESISPage() {
	const navigate = useNavigate()
	const { config } = useVESISParams()

	const match = useMatch('/vesis/:network/*')
	const networkSlug = match?.params.network

	const wallet = useWallet()

	const [isAboutLockDisabled, setIsAboutLockDisabled] = useState(false)

	const { data, isLoading } = useLockDetails(() => {
		if (!isAboutLockDisabled) {
			return
		}

		setIsAboutLockDisabled(false)
	})

	let rightLink: React.ReactNode
	if (data && !isLockDateExpired(data.end.toNumber())) {
		rightLink = (
			<IconButton
				className={styles.settings}
				icon={SettingsIcon}
				as={Link}
				to={`/vesis/${config.slug}/settings`}
			/>
		)
	}

	let lockContent: React.ReactNode
	if (isLoading || wallet.status === WalletStatus.CONNECTING) {
		lockContent = <Spinner className={styles.spinner} />
	} else if (data) {
		const onClaimSuccess = () => {
			setIsAboutLockDisabled(true)
		}

		lockContent = (
			<AboutLock
				disabled={isAboutLockDisabled}
				lock={data}
				onClaimSuccess={onClaimSuccess}
			/>
		)
	} else {
		lockContent = <NoActiveLock />
	}

	return (
		<div className={styles.page}>
			<Helmet>
				<title>Your Lock</title>
			</Helmet>

			<Tile>
				<div className={styles.container}>
					<PageHeader
						title="Your Lock"
						onQuestionClick={() => {
							window.open(
								'https://docs.symbiosis.finance/liquidity-providers/vesis',
								'_blank'
							)
							// TODO show bubbles
						}}
						rightLink={
							<div className={styles.rightLinks}>
								{rightLink}
								<Select
									options={OPTIONS}
									value={networkSlug}
									onChange={({ value }) =>
										navigate(`/vesis/${value}`)
									}
								/>
							</div>
						}
					/>

					{lockContent}
					<TotalStakingOverview />
				</div>
			</Tile>
		</div>
	)
}
